export default __webpack_public_path__ + "static/media/suy.2283fd27.jpg";